import React from 'react';
import { Row, Col, Table } from 'reactstrap';

const Roles = ({ roles }) => {
  return (
    <div>
      <Row>
        <Col>
          <div className="content-heading">
            <div>
              Roles
              <small>Roles which are currently available in the DB.</small>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <Table striped bordered style={{ minWidth: '800px' }}>
              <thead>
                <tr>
                  <th></th>
                  <th>Role Name</th>
                </tr>
              </thead>
              <tbody>
                {roles.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Roles;
